import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { SafeUrl } from "@angular/platform-browser";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { AvatarService } from "src/app/core/services/avatar.service";

@Component({
	selector: "af-avatar",
	templateUrl: "./avatar.component.html",
	styleUrls: ["./avatar.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent implements OnInit, OnDestroy {
	@Input() alt = "";
	@Input() height: string;
	@Input() employeeId: string;
	@Input() width: string;

	avatar: SafeUrl | null = null;
	isLoading = false;

	private destroy$ = new Subject<void>();

	constructor(private avatarService: AvatarService, private cdr: ChangeDetectorRef) {}

	async ngOnInit() {
		if (!this.employeeId) {
			return;
		}

		// First check if avatar is already available
		this.avatar = this.avatarService.getAvatarUrl(this.employeeId);

		if (this.avatar) {
			this.cdr.markForCheck();
			return;
		}

		// Subscribe to avatar updates for this employee
		this.avatarService
			.getAvatar$(this.employeeId)
			.pipe(takeUntil(this.destroy$))
			.subscribe((avatarUrl) => {
				this.avatar = avatarUrl;
				this.cdr.markForCheck();
			});

		// If no avatar found, try to load it individually
		if (!this.avatarService.hasAvatar(this.employeeId)) {
			this.isLoading = true;
			this.cdr.markForCheck();

			try {
				await this.avatarService.loadMissingAvatar(this.employeeId);
			} catch (error) {
				console.error(`Failed to load avatar for employee ${this.employeeId}:`, error);
			} finally {
				this.isLoading = false;
				this.cdr.markForCheck();
			}
		}
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
